import { globalAlertSlice } from './slices/alert.slice'
import { globalSettingsSlice } from './slices/settings.slice'

export const calculationReducerPath = 'calculation'
export const uiReducerPath = 'ui'

export const selectCalculationState = (state) => state[calculationReducerPath]
export const selectUIState = (state) => state[uiReducerPath]

// LEGACY SELECTORS
export const getGlobalSettingsState = (state) => state[globalSettingsSlice.name]
export const getGlobalAlertState = (state) => state[globalAlertSlice.name]
export const getCalculationState = (state) => selectCalculationState(state)
export const getUIState = (state) => selectUIState(state)

export const getCalcInputState = (state) => getCalculationState(state).input
export const getCalcOutputState = (state) => getCalculationState(state).output
export const getCalcStatusState = (state) => getCalculationState(state).status
